import type { ReactNode } from 'react';
import { useState } from 'react';
import classNames from 'classnames';

export interface OffCanvasPaneProps {
  visible?: boolean;
  className?: string;
  children?: ReactNode;
}

export const OffCanvasPane = ({ visible, className, children }: OffCanvasPaneProps) => {
  const [localVisible, setVisible] = useState(false);
  const isVisible = visible === undefined ? localVisible : visible;

  return (
    <div
      data-testid="off-canvas-pane"
      className={classNames(
        'bg-white text-black fixed right-0 top-0 bottom-0 p-15',
        navigator.userAgent.match(/iPhone|iPad/) ? '' : 'transform-gpu transition-transform',
        isVisible ? '' : 'translate-x-full',
        className
      )}
      onClick={() => setVisible(false)}
    >
      {children}
    </div>
  );
};
